import React from "react";
import "./astrology.scss";
import mobile1 from "../../assets/mobiles/1.png";
import mobile2 from "../../assets/mobiles/2.png";
import mobile3 from "../../assets/mobiles/3.png";
import mobile4 from "../../assets/mobiles/4.png";
import mobile5 from "../../assets/mobiles/5.png";
import mobile6 from "../../assets/mobiles/6.png";
import mobile7 from "../../assets/mobiles/7.png";
import mobile8 from "../../assets/mobiles/8.png";
import mobile9 from "../../assets/mobiles/9.png";
import mobile10 from "../../assets/mobiles/10.png";
import mobile11 from "../../assets/mobiles/11.png";
import mobile12 from "../../assets/mobiles/12.png";
import { useState, useEffect } from "react";
import { db } from "../../firebase_setup/firebase";
import { doc, getDoc } from "firebase/firestore";

const AstrologySolution = () => {
  async function fetch() {
    const docSnap = await getDoc(docRef);
    if (docSnap) {
      setAstro(docSnap.data());
    }


    console.log(astroHeading["body"]);
  }

  const [astroHeading, setAstro] = useState({});
  const docRef = doc(db, "astrology", "47WtAYvx0cIqo0VUX9HP");
  useEffect(() => {
    fetch();
  });
  return (
    <div className="astrology-solution" id="feature">
      <div className="astrology-heading">
        <h1>
          {astroHeading["heading"] ? astroHeading["heading"].substring(0, 4) : ""} <span> {astroHeading["heading"] ? astroHeading["heading"].substring(5, 15) : ""}</span> {astroHeading["heading"] ? astroHeading["heading"].substring(16, 41) : ""}
        </h1>
        <p>
          {astroHeading["body"] ? astroHeading["body"].substring(0, astroHeading["body"].length) : ""}
        </p>
      </div>
      <div className="mobile-grid-main-container">
        <div className="mobile-card">
          <div className="image-container">
            <img className="img1" src={mobile1} alt="" />
            <img className="img2" src={mobile2} alt="" />
          </div>
          <div className="heading">
            <h6>FreshPage</h6>
            <p>
              {astroHeading["cards"] ? astroHeading["cards"]["FreshPage"] : ""}
            </p>
          </div>
        </div>
        <div className="mobile-card">
          <div className="image-container">
            <img className="img1" src={mobile3} alt="" />
            <img className="img2" src={mobile4} alt="" />
          </div>
          <div className="heading">
            <h6>Organize Engaging Quiz Challenges: </h6>
            <p>
              {astroHeading["cards"] ? astroHeading["cards"]["Organize Engaging Quiz Challenges: "] : ""}
            </p>
          </div>
        </div>
        <div className="mobile-card">
          <div className="image-container">
            <img className="img1" src={mobile5} alt="" />
            <img className="img2" src={mobile6} alt="" />
          </div>
          <div className="heading">
            <h6>Book at your Doorstep </h6>
            <p>
              {astroHeading["cards"] ? astroHeading["cards"]["Book at your Doorstep "] : ""}
            </p>
          </div>
        </div>
        <div className="mobile-card">
          <div className="image-container">
            <img className="img1" src={mobile7} alt="" />
            <img className="img2" src={mobile8} alt="" />
          </div>
          <div className="heading">
            <h6>Challenges: </h6>
            <p>
              {astroHeading["cards"] ? astroHeading["cards"]["Challenges: "] : ""}
            </p>
          </div>
        </div>
        <div className="mobile-card">
          <div className="image-container">
            <img className="img1" src={mobile9} alt="" />
            <img className="img2" src={mobile10} alt="" />
          </div>
          <div className="heading">
            <h6>🏆 Daily Rewards: </h6>
            <p>
              {astroHeading["cards"] ? astroHeading["cards"]["🏆 Daily Rewards: "] : ""}
            </p>
          </div>
        </div>
        <div className="mobile-card">
          <div className="image-container">
            <img className="img1" src={mobile11} alt="" />
            <img className="img2" src={mobile12} alt="" />
          </div>
          <div className="heading">
            <h6>Delivery Services:</h6>
            <p>
              {astroHeading["cards"] ? astroHeading["cards"]["Delivery Services:"] : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AstrologySolution;
